import React from "react";
import { BrowserRouter } from "react-router-dom";

import { Container } from "./App.styles";
import GlobalStyle from "./styles/global";
import { AppRoutes } from "./routes";
import { AppProvider } from "./hooks";
import AppMenu from "./components/appMenu/AppMenu";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Container>
        <AppProvider>
          {!(
            window.location.pathname.includes("/follow-up/") ||
            window.location.pathname.includes("/results/") ||
            window.location.pathname.includes("/best-collectors/")
          ) && <AppMenu />}
          <GlobalStyle />
          <AppRoutes />
        </AppProvider>
      </Container>
    </BrowserRouter>
  );
};

export default App;
